import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SuperAdminLayout } from "@/components/SuperAdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  ChefHat,
  Clock,
  AlertCircle,
  CheckCircle,
  RefreshCw,
  ArrowLeft,
} from "lucide-react";
import { toast } from "react-hot-toast";

export default function SuperAdminKitchenMonitor() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const refreshData = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      toast.success("Data refreshed");
    }, 1000);
  };

  return (
    <SuperAdminLayout>
      <div>
        {/* Page Header */}
        <div
          className="mb-8 flex justify-between w-full items-center px-6
  bg-gradient-to-r from-orange-500 to-red-500
  shadow-md text-white py-[1.65rem]"
        >
          <div className="flex items-center gap-4">
            <Button
              onClick={() => navigate("/admin/dashboard")}
              variant="ghost"
              className="hover:bg-gray-100"
            >
              <ArrowLeft size={20} />
            </Button>
            <div>
              <h1 className="text-3xl font-bold">
                Kitchen Monitor
              </h1>
              <p className="mt-1">
                Live KOT status across all restaurant outlets
              </p>
            </div>
          </div>
          <Button
            onClick={refreshData}
            disabled={loading}
             className="bg-white text-red-600 hover:bg-orange-500 hover:text-white transition-colors duration-200"
          >
            <RefreshCw
              className={`h-4 w-4 mr-2 ${loading ? "animate-spin" : ""}`}
            />
            Auto-Refresh: 30s
          </Button>
        </div>
        <div className="p-8">
          {/* Kitchen Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  Active KOTs
                </CardTitle>
                <ChefHat className="h-5 w-5 text-gray-400" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-gray-900">0</div>
                <p className="text-xs text-gray-500 mt-1">Across all outlets</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  Pending Items
                </CardTitle>
                <Clock className="h-5 w-5 text-gray-400" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-yellow-600">0</div>
                <p className="text-xs text-gray-500 mt-1">Waiting to prepare</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  In Progress
                </CardTitle>
                <AlertCircle className="h-5 w-5 text-gray-400" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-blue-600">0</div>
                <p className="text-xs text-gray-500 mt-1">Being prepared</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  Ready
                </CardTitle>
                <CheckCircle className="h-5 w-5 text-gray-400" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-green-600">0</div>
                <p className="text-xs text-gray-500 mt-1">Ready to serve</p>
              </CardContent>
            </Card>
          </div>

          {/* Coming Soon Message */}
          <Card>
            <CardContent className="p-12 text-center">
              <ChefHat className="h-16 w-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Kitchen Monitor Coming Soon
              </h3>
              <p className="text-gray-600 max-w-md mx-auto">
                Live kitchen order tracking across all outlets will be available
                here. Monitor KOT status, preparation times, and kitchen
                performance in real-time.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </SuperAdminLayout>
  );
}
